import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { searchPrivilegeUsers, searchUsers } from './thunks'

const initialState: UsersState = {
  users: [],
  error: null,
  status: 'idle',
  searchFilters: {},
}

const slice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    updateUsers: (state, action) => {
      state.users = action.payload
    },
    saveSearchFilters: (state, action) => {
      state.searchFilters = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchUsers.pending, (state, action) => {
        state.status = 'loading'
        state.error = null
        const { offset } = action.meta.arg
        const isFirstFetch = [0, undefined].includes(offset)
        if (isFirstFetch) {
          state.users = []
        }
      })
      .addCase(searchUsers.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(searchUsers.fulfilled, (state, action) => {
        state.status = 'succeeded'
        const { offset } = action.meta.arg
        const isFirstFetch = [0, undefined].includes(offset)
        state.users = isFirstFetch ? action.payload : state.users.concat(action.payload)
      })
      .addCase(searchPrivilegeUsers.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(searchPrivilegeUsers.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(searchPrivilegeUsers.fulfilled, (state) => {
        state.status = 'succeeded'
      })
  },
})

export const { updateUsers, saveSearchFilters } = slice.actions

export const selectUsers = (state: RootState): UsersState => state.users

export default slice.reducer
